export default __webpack_public_path__ + "static/media/DAIF_Extra2_Screen1_in-end.da432f51.jpg";